import ImageComponent from "ui/components/shared/ImageComponent"
import MySkillsIcon from 'assets/icons/Myskills.png'
import MySkillsActiveIcon from 'assets/icons/Myskills-active.png'
import SkillboardIcon from 'assets/icons/Skillboard.png'
import SkillboardActiveIcon from 'assets/icons/Skillboard-active.png'
import SkillaryIcon from 'assets/icons/Skillary.png'
import SkillaryActiveIcon from 'assets/icons/Skillary-active.png'
import SkillboxIcon from 'assets/icons/Skillbox.png'
import SkillboxActiveIcon from 'assets/icons/Skillbox-active.png'
import SkillcardIcon from 'assets/icons/Skillcards.png'
import SkillcardActiveIcon from 'assets/icons/Skillcards-active.png'
import Home from "ui/pages/myskills"
import Skills from "ui/pages/skills"
import Library from "ui/pages/skillary"
import { SelectedSkillContextProvider } from "data/index"
import Skillbox from "ui/pages/skillbox"
import Skillcards from "ui/pages/Skillcards/Skillcards"
import { RoutesInterface } from "./interfaces"
import SettingsIconD from 'assets/icons/Settings-desktop.png'
import SettingsIcon from 'assets/icons/Settings.png'
import SettingsIconDark from 'assets/icons/Settings-dark.png'
import SettingsIconMobileActive from 'assets/icons/settings-Filled.png'
import Settings from "ui/pages/settings"
import SkillboxLearnings from "ui/components/pages/skillbox/SkillboxLearnings"

import MobilePersonalSettings from 'ui/components/mobile/settings/MobilePersonalSettings'
import MobileLearningSettings from "ui/components/mobile/settings/MobileLearningSettings"
import MobileAvatarSettings from "ui/components/mobile/settings/MobileAvatarSettings"
import MobileNotificationSettings from "ui/components/mobile/settings/MobileNotificationSettings"
import MobileSecuritySettings from "ui/components/mobile/settings/MobileSecuritySettings"
import MobileFeedbackSettings from "ui/components/mobile/settings/MobileFeedbackSettings"
import MobilePrivacySettings from "ui/components/mobile/settings/MobilePrivacySettings"

import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';

export const MobileSettingsRoutes: RoutesInterface[] = [
    {
        title: 'Personal Settings',
        link: '/mobile/settings/personal',
        icon: <PersonOutlineIcon />,
        iconDark: <PersonOutlineIcon />,
        iconMobile: <PersonOutlineIcon />,
        iconActiveMobile: <PersonOutlineIcon />,
        component: <MobilePersonalSettings />,
    },
     
    {
        title: 'Learning Settings',
        link: '/mobile/settings/learning',
        icon: <SchoolOutlinedIcon />,
        iconDark: <SchoolOutlinedIcon />,
        iconMobile: <SchoolOutlinedIcon />,
        iconActiveMobile: <SchoolOutlinedIcon />,
        component: <MobileLearningSettings/>,
    },
    
    {
        title: 'Avatar Settings',
        link: '/mobile/settings/avatar',
        icon: <AccountCircleOutlinedIcon />,
        iconDark: <AccountCircleOutlinedIcon />,
        iconMobile: <AccountCircleOutlinedIcon />,
        iconActiveMobile: <AccountCircleOutlinedIcon />,
        component: <MobileAvatarSettings />,
    },
   

    {
        title: 'Notifications Settings',
        link: '/mobile/settings/notifications',
        icon: <NotificationsNoneOutlinedIcon />,
        iconDark: <NotificationsNoneOutlinedIcon />,
        iconMobile: <NotificationsNoneOutlinedIcon />,
        iconActiveMobile: <NotificationsNoneOutlinedIcon />,
        component: <MobileNotificationSettings />,
    },
    
        {
        title: 'Security Settings',
        link: '/mobile/settings/security',
        icon: <SecurityOutlinedIcon />,
        iconDark: <SecurityOutlinedIcon />,
        iconMobile: <SecurityOutlinedIcon />,
        iconActiveMobile: <SecurityOutlinedIcon />,
        component: <MobileSecuritySettings/>,
    },
    
    {
        title: 'Feedback',
        link: '/mobile/settings/feedback',
        icon: <FeedbackOutlinedIcon />,
        iconDark: <FeedbackOutlinedIcon />,
        iconMobile: <FeedbackOutlinedIcon />,
        iconActiveMobile: <FeedbackOutlinedIcon />,
        component: <MobileFeedbackSettings/>,
    },
   
    {
        title: 'Privacy',
        link: '/mobile/settings/privacy',
        icon: <ArticleOutlinedIcon />,
        iconDark: <ArticleOutlinedIcon />,
        iconMobile: <ArticleOutlinedIcon />,
        iconActiveMobile: <ArticleOutlinedIcon />,
        component: <MobilePrivacySettings />,
    },
    
];

export const Routes: RoutesInterface[] = [
    {
        title: 'MySkills',
        link: '/myskills',
        icon: <ImageComponent src={MySkillsIcon} alt="mySkills" />,
        iconDark: <ImageComponent src={MySkillsActiveIcon} alt="mySkills"/>,
        iconMobile: <ImageComponent src={MySkillsIcon} alt="mySkills" />,
        iconActiveMobile: <ImageComponent src={MySkillsActiveIcon} alt="mySkills" />,
        component: (
            <Home />
        ),
    },
    {
        title: 'Skillary',
        link: '/skillary',
        icon: <ImageComponent src={SkillaryIcon} alt="skillary" />,
        iconDark: <ImageComponent src={SkillaryActiveIcon} alt="skillary" />,
        iconMobile: <ImageComponent src={SkillaryIcon} alt="skillary" />,
        iconActiveMobile: <ImageComponent src={SkillaryActiveIcon} alt="skillary" />,
        component: (
            <SelectedSkillContextProvider>
                <Library />
            </SelectedSkillContextProvider>
        ),
    },
    {
        title: 'Skillboard',
        link: '/skillboard',
        icon: <ImageComponent src={SkillboardIcon} alt="skillboard" />,
        iconDark: <ImageComponent src={SkillboardActiveIcon} alt="skillboard" />,
        iconMobile: <ImageComponent src={SkillboardIcon} alt="skillboard" />,
        iconActiveMobile: <ImageComponent src={SkillboardActiveIcon} alt="skillboard" />,
        component: (
            <Skills />
        ),
    },

    {
        title: 'Skillbox',
        link: '/skillbox',
        icon: <ImageComponent src={SkillboxIcon} alt="skillbox" />,
        iconDark: <ImageComponent src={SkillboxActiveIcon} alt="skillbox" />,
        iconMobile: <ImageComponent src={SkillboxIcon} alt="skillbox" />,
        iconActiveMobile: <ImageComponent src={SkillboxActiveIcon} alt="skillbox" />,
        component: (
            <Skillbox/>
        ),
        children: [
            {
                title: 'Skillbox Learnings',
                link: '/skillbox/:courseId',  // Dynamische Route mit Course-ID,
                icon: "",
                iconDark: "",
                iconMobile:"",
                iconActiveMobile: "",
                component: <SkillboxLearnings />,
            }
        ]
    },
    {
        title: 'Skillcards',
        link: '/skillcards',
        icon: <ImageComponent src={SkillcardIcon} alt="Skillcard" />,
        iconDark: <ImageComponent src={SkillcardActiveIcon} alt="Skillcard" />,
        iconMobile: <ImageComponent src={SkillcardIcon} alt="Skillcard" />,
        iconActiveMobile: <ImageComponent src={SkillcardActiveIcon} alt="Skillcard" />,
        component: (
            <Skillcards/>
        ),
    },
    

]

export const AllRoutes: RoutesInterface[] = [
    ...Routes,           
    ...MobileSettingsRoutes  
];
